import styled from 'styled-components';

export const PaginationContainer = styled.div`
  display: flex;

  @media (${({ theme }) => theme.MEDIA_MAX.mobile}) {
    justify-content: center;
  }

  .rc-pagination {
    margin-top: 1rem;
    margin-bottom: 1rem;
    font-size: 1.2rem;
  }
}

button.rc-pagination-item-link {
  background-color: transparent;
  border: none;
}

.rc-pagination-item {
  border: none;
  border-radius: 50%;
  font-weight: bold;


  &:hover button {
    color: ${({ theme }) => theme.COLORS.secondary};
  }

  &:focus {
    outline: none;
  }
}

.rc-pagination-next,
.rc-pagination-prev,
.rc-pagination-item {
  box-shadow: 0 0 20px 1px rgba(0, 0, 0, 0.25);
}

.rc-pagination-jump-prev:hover:after,
.rc-pagination-jump-next:hover:after {
  color: ${({ theme }) => theme.COLORS.primaryMiddle};
}

.rc-pagination-item {
  line-height: 2.8rem;
  
  &:hover {
    & > a {
      color: ${({ theme }) => theme.COLORS.secondary};
    }
  }
  
  & > a {
    color: ${({ theme }) => theme.COLORS.secondaryMiddle};
  }
}

.rc-pagination-item.rc-pagination-item-active {
  background-color: ${({ theme }) => theme.COLORS.primaryMiddle};

  & > a {
    color: ${({ theme }) => theme.UI_COLORS.light};
  }
}


.rc-pagination-prev,
.rc-pagination-next {
  border-radius: 50%;
`;
